export default __webpack_public_path__ + "static/bg-numbers-82b8b94a23939718e32d87b6c3ba2242.webp";